<script lang="ts">
  import AUButton from "component_library/components/svelte/ui/AUButton.svelte"
  import AUText from "component_library/components/svelte/ui/AUText.svelte"
  import { getContext } from "svelte"
  import type { Settings } from "website_script/types/settings"
  import Svg from "../components/Svg.svelte"
  import { leadFlowIcon } from "conversion_flows/types/leadFlowIcons"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import themeTokens from "conversion_flows/theme/LibUIThemeTokens"
  import ChevronRight from "@autouncle/icons/dist/assets/chevron-right.svg?raw"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import { getFlowsContext } from "website_script/contexts/flows"

  const dealerTheme = getContext<DealerTheme>("dealerTheme")
  const { routerConfig } = getContext<Settings>("settings")
  const { triggerFlow } = getFlowsContext()
  const { buttons, title, description } = routerConfig

  const tokens = themeTokens(dealerTheme)
</script>

<div class="au-widget-router">
  <div>
    <AUText
      role="heading"
      ariaLevel={2}
      color="default"
      font="body-base"
      weight="bold">{title}</AUText
    >
    <AUText role="paragraph" color="body" font="body-small"
      >{description}</AUText
    >
  </div>
  <div class="au-widget-router__buttons">
    {#each buttons as buttonConfig}
      <div class="au-widget-router__button">
        <AUButton
          fullWidth
          textAlign="left"
          color="link"
          onClick={() =>
            triggerFlow(buttonConfig, IntegrationTypes.WIDGET_ROUTER)}
        >
          <Svg
            color={String(tokens("colors.grey.100"))}
            alt={buttonConfig.text}
            aria-hidden="true"
            data={leadFlowIcon(buttonConfig.icon)}
            slot="leftIcon"
          />
          {buttonConfig.text}
          <Svg
            color={String(tokens("colors.primary.500"))}
            alt="arrow"
            aria-hidden="true"
            data={ChevronRight}
            slot="rightIcon"
          />
        </AUButton>
      </div>
    {/each}
  </div>
</div>

<style>
  .au-widget-router {
    display: flex;
    flex-direction: column;
    gap: var(--au-spacing-lg);
  }

  .au-widget-router__buttons {
    display: flex;
    flex-direction: column;
  }

  .au-widget-router__button :global(.au-button[data-size="md"]) {
    --au-button-padding: 0;
    --au-button-color: var(--au-button-secondary-color);
  }

  .au-widget-router__button:not(:last-child) {
    padding-bottom: var(--au-spacing-xs);
    border-bottom: var(--au-line-width-default) solid
      var(--au-line-color-neutral);
  }

  .au-widget-router__button:not(:first-child) {
    padding-top: var(--au-spacing-xs);
  }
</style>
